export const TRENDS_ORGANIZATION_SETTING_GROUPS = [
    {
        title: 'Machine learning & responses',
        settings: [
            {key: 'mlTaggable', label: 'ML tagging'},
            {key: 'shouldAlwaysGenerateResponses', label: 'Always generate responses'},
            {key: 'isTaggingV2Enabled', label: 'Tagging v2'},
        ],
    },
    {
        title: 'Teams integration',
        settings: [
            {key: 'isTeamsNotificationEnabled', label: 'Teams notifications'},
            {key: 'datasourcesEnabled', label: 'Data sources enabled'},
        ],
    },
    {
        title: 'Search & UI',
        settings: [
            {key: 'isSearchEnabled', label: 'Search'},
            {key: 'isSummaryTabEnabled', label: 'Summary tab'},
        ],
    },
    {
        title: 'Filters',
        settings: [
            {key: 'isShopFilterEnabled', label: 'Shop filter'},
            {key: 'isEmailFilterEnabled', label: 'Email filter'},
            {key: 'isMetaDataFilterEnabled', label: 'Metadata filter'},
            {key: 'isKustomerTagsMetaDataFilterEnabled', label: 'Kustomer tags metadata filter'},
        ],
    },
    {
        title: 'Webhooks & sync',
        settings: [
            {key: 'isShopifyWebhookEnabled', label: 'Shopify webhook'},
            {key: 'isZendeskWebhookEnabled', label: 'Zendesk webhook'},
            {key: 'isBacklogFetchEnabled', label: 'Backlog fetch'},
        ],
    },
    {
        title: 'Analytics',
        settings: [
            {key: 'isIbmSentimentEnabled', label: 'IBM sentiment'},
        ],
    },
];
